import { useHomeContext } from '@/context/homeContext';
import useDateHandler from '@/hooks/useDateHandler';
import Image from 'next/image';
import React from 'react'

const DateTitle = ({ handleShowCalendar }) => {
  const {
    filterForm,
    setFilterForm,
    selectedDatesFilter,
    setSelectedDatesFilter,
  } = useHomeContext();

  const { dayStart, dayEnd, monthStart, monthEnd } = useDateHandler(
    filterForm,
    setFilterForm,
    selectedDatesFilter,
    setSelectedDatesFilter
  );
  return (
    <div
      className="flex flex-col items-start gap-1 px-4 py-1.5 xsm:border-r cursor-pointer border-[#ECEFF5]"
      onClick={handleShowCalendar}
    >
      <span className="text-[#9DADC0] text-xs font-medium leading-normal tracking-[1.8px]">
        GİRİŞ ÇIKIŞ
      </span>
      <div className="flex items-center justify-between w-full">
        <span className="text-sm font-medium leading-normal tracking-tight text-themeBlack">
          {dayStart} {monthStart} - {dayEnd} {monthEnd}
        </span>
        <Image
          src="/icons/calendar.svg"
          width={24}
          height={24}
          alt="calendar"
        />
      </div>
    </div>
  );
};

export default DateTitle